<template>
  <span>
    <main role="main">



      <div id="myCarousel" class="carousel slide" data-bs-ride="carousel">

        <ul class="carousel-inner">
          <li class="carousel-item" :class="index == 0 ? 'active' : ''"
            v-for="(hero, index)  in content.homepage.body.hero_images" v-bind:key="index">
            <div class="container">
              <div class="carousel-caption text-start">
                <h1>Find properties to rent in the uk.</h1>
                <p>Search for properties across uk.</p>
                <p><a class="btn btn-lg btn-primary" href="/sections/whitelabel/rentalSearch/renting_search.jsp"
                    role="button">Properties to rent</a></p>
              </div>
              <!--div class="container">
              <div class="carousel-caption text-start">
                <h1>*7% NET Rental Return.</h1>
                <ul>
                  <li>Completed and Tenanted</li>
                  <li>Rental Income Available</li>
                  <li>Student Property Investment</li>
                  <li>20.5% Projected Capital Growth by 2027</li>
                </ul>
                <details>
                  <summary> * Investment Risk Warning</summary>
                  <p>
                    * Returns are not guaranteed. As with all investments there are risks. Please make sure you read and understand the Risk Warnings.
                  </p>
                </details>                
                
                <form id="formR1" method="post" action="/sections/contact/agents/global_contactus.jsp"
                  class="inlineDisplay">
                  <fieldset class="inlineDisplay">
                    <input type="hidden" name="subject"
                      value="Property enquiry through hometolive.com : 7% NET Rental Return. LVP Area UK">
                    <input type="submit" name="submit" value="Enquire >" class="btn btn-lg btn-primary">
                  </fieldset>
                </form>



              </div>-->
            </div>
            <!--<img src="/pub/vu/assets/images/hero4_blur.jpg" loading="lazy" style="object-fit: cover;" alt="" />-->

            <img :src="`${content.homepage.body.hero_images[index]}`"
              :alt="`${content.homepage.body.alt[0]} ${index+1}`" :title="`${content.homepage.body.alt[0]} ${index+1}`" />


          </li>
          <li>
            <ul class="carousel-indicators">
              <li  
              v-for="(hero, index)  in content.homepage.body.hero_images" v-bind:key="index">
                <button type="button" data-bs-target="#myCarousel" :data-bs-slide-to="`${index}`" :class="index == 0 ? 'active' : ''"
                  aria-current="true" :aria-label="`Slide ${index}`"> </button>
              </li>

            </ul>
          </li>



        </ul>

        <button class="carousel-control-prev" type="button" data-bs-target="#myCarousel" data-bs-slide="prev">
          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
          <span class="visually-hidden">Previous</span>
        </button>
        <button class="carousel-control-next" type="button" data-bs-target="#myCarousel" data-bs-slide="next">
          <span class="carousel-control-next-icon" aria-hidden="true"></span>
          <span class="visually-hidden">Next</span>
        </button>
      </div>
    </main>
  </span>
</template>




<script>

import $ from "jquery";
import AllContent from '../data/content';

//const { content, introVideo } = AllContent.other;

export default {
  name: 'Homepage',

  data() {
    return {
      content: AllContent,
      publicPath: process.env.BASE_URL

    };
  },
  mounted: function () {
    let pagename;
    pagename = this.$route.name;
    document.querySelector('body').id = pagename

    function preloader() {

      setInterval(function () {
        changeImage()
      }, 400);

    }

    function changeImage() {
      if (pagename === "Homepage") {


        $("#Homepage .carousel-item:first-child img").attr("src", "images/hero4.jpg");

      }
    }
    preloader()
  },

};
</script>

<style lang="scss">
#homepage.fadein {
  opacity: 100;
  transition: opacity 2s ease-IN;
}

.carousel-caption {
  ul {
    li {
      list-style: none;
    }
  }

  details {
    margin: 0 0 5px 0;

    p {
      font-size: 0.8rem;
      padding: 5px;
    }
  }
}

#myCarousel ul li img {
  object-fit: cover;
}</style>
